import { useSessionStorage } from 'react-use';
import dayjs from 'dayjs';

const useHoldTime = () => {
  const [holdTime] = useSessionStorage<string>('hold-time');
  return dayjs(holdTime as string).diff(dayjs(), 'seconds');
};

export default useHoldTime;
